/**
 * @generated SignedSource<<4f46f0ab5f89bcdef2c4b9640bb57663>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineEditMainOrgTopicListItemSelector_topics$data = ReadonlyArray<{
  readonly description: string | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "RoutineEditMainOrgTopicListItemSelector_topics";
}>;
export type RoutineEditMainOrgTopicListItemSelector_topics$key = ReadonlyArray<{
  readonly " $data"?: RoutineEditMainOrgTopicListItemSelector_topics$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainOrgTopicListItemSelector_topics">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RoutineEditMainOrgTopicListItemSelector_topics",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "OrgTopic",
  "abstractKey": null
};

(node as any).hash = "dd4b25981fe6b7e0334f48c6824ad06c";

export default node;
